<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
import SharedMessage from "@/components/shared/SharedMessage.vue";
import SharedCommentForm from "@/components/shared/SharedCommentForm.vue";
import TicketService from "@/api/services/ticket.service";

import { onMounted, ref } from "vue";


const props = defineProps({
  title: {
    type: String,
    required: true
  },
  placeholder: {
    type: String
  },
  isPrivate: {
    type: Boolean,
    required: true
  },
  ticket: {
    type: Object,
    required: true
  }
});

const messages = ref([]);

// Los comentarios no vienen en el ticket: se piden aparte y el back ya filtra los que puede ver el usuario
async function loadComments() {
  if (!props.ticket?.id) {
    messages.value = [];
    return;
  }
  const response = await TicketService.getTicketComments(props.ticket.id);
  const comments = response?.data?.['hydra:member'] ?? response?.data ?? [];
  messages.value = comments.filter(item => item.private === props.isPrivate);
}

onMounted(loadComments);
</script>

<template>
  <div class="container m-0 p-0 mt-3">
    <img
      src="@/assets/icons/message.svg"
      alt=""
    >
    <div class="title-text ml-4 d-inline-block">
      {{ title }}
    </div>
    <div class="ticket-messages">
      <SharedMessage
        v-for="message in messages"
        :key="message.id"
        :message="message"
      />
      <SharedCommentForm
        :is-private="isPrivate"
        :ticket="ticket"
        title=""
        :placeholder="placeholder"
        @refresh="loadComments"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .ticket-messages {
    border: 1px solid;
    border-radius: 25px;
    background-color: white;
    padding: 15px;
    margin-top: 25px;
  }
</style>
